
export const PokemonCard=({currr})=>{
    return(
        <>
              <figure>
                <img
                  src={currr.sprites.other.dream_world.front_default}
                  alt={currr.name}
                  className="pokemon-image"
                />
              </figure>
                    <h1 className="pokemon-name">{currr.name}</h1>
                <div className="pokemon-info pokemon-highlight">
                  <p>{currr.types.map((currtype)=>currtype.type.name)}</p>
                </div>
                <div className="grid-three-cols">
                  <p className="pokemon-info"><span>Height:{currr.height}</span></p>
                  <p className="pokemon-info"><span>Weight:{currr.weight}</span></p>
                  <p className="pokemon-info"><span>Speed:{currr.stats[5].base_stat}</span></p>
                </div>
        </>
    );
}